import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IdentityComponent} from "./identity.component";
import {BarcodeListComponent} from "./barcode/barcode-list/barcode-list.component";
import {NewBarcodeFormComponent} from "./new-barcode-form/new-barcode-form.component";
import {BarcodeService} from "./services/barcode.service";
import {VisbosCoreModule} from "../core/visbos-core/visbos-core.module";
import {ReactiveFormsModule} from "@angular/forms";
import {RfidReaderComponent} from './rfid/rfid-reader/rfid-reader.component';
import {RfidService} from './services/rfid.service';
import {IdentitiesComponent} from './identities/identities.component';

@NgModule({
  imports: [
    CommonModule, ReactiveFormsModule, VisbosCoreModule
  ],
  declarations: [IdentityComponent, BarcodeListComponent, NewBarcodeFormComponent, RfidReaderComponent, IdentitiesComponent],
  providers: [BarcodeService, RfidService],
  exports: [BarcodeListComponent, IdentityComponent, NewBarcodeFormComponent, RfidReaderComponent, IdentitiesComponent]
})
export class IdentityModule {
}



// WEBPACK FOOTER //
// ./src/app/identity/identity.module.ts